<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Button from "./Button.svelte";
  import Icon from "./Icon.svelte";

  export let klass: string = "is-primary";
  export let text: string = "";

  let inputElement: HTMLInputElement;

  const dispatch = createEventDispatcher();

  function onUploadFile() {
    inputElement.click();
  }

  function onInputChange() {
    const file = inputElement.files.item(0);
    fileToText(file, (text) => {
      //save(text, "file.txt", "text/plain");
      const blob = new Blob([text], {
        type: "text/plain",
      });
      dispatch("fileUpload", blob);
    });
  }

  function fileToText(file: File, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      callback(reader.result);
    };
  }

  // function save(content, fileName, mime) {
  //   const blob = new Blob([content], {
  //     type: mime,
  //   });
  //   dispatch("fileUpload", blob);
  //   //const url = URL.createObjectURL(blob);
  //   // const a = document.createElement("a");
  //   // a.href = url;
  //   // a.download = fileName;
  //   // a.click();
  // }

  // accept="text/plain"
</script>

<span class="whole-btn">
  <input class="hidden-input" type="file" bind:this={inputElement} on:change={onInputChange} />
  <Button {klass} on:click={onUploadFile}>
    <Icon name="note_add" handleClick={false} />
    <span>{text}</span>
  </Button>
</span>

<style>
  .hidden-input {
    /*visibility: hidden;*/
    display: none;
  }

  .whole-btn {
    display: inline-block;
  }
</style>
